import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { MasterData } from '../../models/api-response.model';
import { MasterDataService } from '../../services/master_data_service';

@Component({
  selector: 'app-master-data',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './master-data.component.html',
  styleUrls: ['./master-data.component.scss']
})
export class MasterDataComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly service = inject(MasterDataService);
  items: MasterData[] = [];
  currentPage = 1;
  readonly pageSize = 8;
  readonly form = this.fb.nonNullable.group({
    category: ['', [Validators.required, Validators.minLength(2)]],
    code: ['', [Validators.required, Validators.minLength(2)]],
    name: ['', [Validators.required, Validators.minLength(2)]],
    description: ['']
  });

  ngOnInit(): void {
    this.load();
  }

  create(): void {
    if (this.form.invalid) {
      return;
    }
    this.service.create(this.form.getRawValue()).subscribe(() => {
      this.form.reset();
      this.load();
    });
  }

  private load(): void {
    this.service.list().subscribe((response) => {
      this.items = response.value === '' ? [] : response.value;
      this.currentPage = 1;
    });
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.items.length / this.pageSize));
  }

  get paginatedItems(): MasterData[] {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.items.slice(start, start + this.pageSize);
  }

  goToPage(page: number): void {
    this.currentPage = Math.min(Math.max(page, 1), this.totalPages);
  }
}
